function FormFooter() {
  const OnClick = () => {
    const href = 'https://beian.miit.gov.cn/#/Integrated/index'
    window.open(href)
  }
  return (
    <div className='footer'>
      <div className='footer-text'>
        <div className='footer-text-top'>
          <div>
            <div className='footer-href' onClick={OnClick}>备案号：闽ICP备14021829号</div>
            <div>版权所有：福建省劳动就业服务局</div>
            <div>开发单位：福建顶点软件股份有限公司</div>
            <div> 技术支持电话：0591-87677507</div>
            <div>咨询时间：工作日8:30-17:30 </div>
          </div>
          {/* 以下代码为标识证书 */}
          <div>
            <span id='_ideConac'>
              <a
                // eslint-disable-next-line max-len
                href='https://bszs.conac.cn/sitename?method=show&amp;id=09EC6319DABB04AFE053012819AC6A4C'
                target='_blank'
                rel='noopener noreferrer'
              // rel='noreferrer'
              >
                <img
                  alt='福建省劳动就业服务局标识证书'
                  title='福建省劳动就业服务局标识证书'
                  id='imgConac'
                  src='https://dcs.conac.cn/image/blue.png'
                  data-bd-imgshare-binded='1'
                />
              </a>
            </span>
          </div>
        </div>
        {/* <div>
        技术支持：福建众智汇云信息服务有限公司 客服热线：400-619-6823 咨询时间：周一至周五 (8:30 - 12:00 14:00 - 18:00)
      </div> */}

      </div>
    </div>
  )
}
export { FormFooter }